import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { ISFUser } from "@/hooks/useUser";

interface UserState {
  user: ISFUser | null;
  setUser: (user: ISFUser | null) => void;
  clearUser: () => void;
}

export const guestUser: ISFUser = {
  uid: "guest-" + Math.random().toString(36).substring(2, 10),
  datasource: "",
  displayName: "",
  email: "",
  firstName: "",
  lastLoggedIn: 0,
  lastName: "",
  nonce: "",
  referLink: "",
  referral: "",
  registeredAt: 0,
  role: "guest",
  socialSubscriptions: {},
  telegram: false,
  solanaWallet: "",
  timezone: "",
  username: "",
  wallet: "",
  isAdmin: false,
  enableNotifications: false,
};

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: guestUser,
      setUser: (user) => set({ user }),
      clearUser: () => set({ user: null }),
    }),
    {
      name: "sf-user-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
